const loginLeftStyles = {
  container: {
    display: "flex",
    minHeight: '100vh',
  },
  
  help: {
    cursor: "pointer",
    paddingRight: 0,
    textTransform: "capitalize",
    display: { xs: "block", md: "none" }
  }
}

export default loginLeftStyles;